

































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DropDownResponse } from '@/services/__model';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
import moment from 'moment';
@Component
export default class ParentDetail extends Vue {
  @Prop() public emergencyDetailInfo!: any;
  public moment = moment;
  public config = config;

  public get school() {
    return getSchoolInfo().shortName;
  }

  public get locale(): string {
    return this.$i18n.locale;
  }
}
